(() => {
  const script = document.currentScript;
  const more = script.dataset.readMore;
  const less = script.dataset.readLess;
  const mobile = window.matchMedia('(max-width: 767px)');
  function setup() {
    document.querySelectorAll('.rf-collection-extended-description:not([data-guide-ready])').forEach((guide, index) => {
      const content = guide.querySelector('.metafield-rich_text_field');
      if (!content) return;
      const children = Array.from(content.children);
      const firstParagraph = children.findIndex(child => child.tagName === 'P');
      const remainder = children.slice(firstParagraph + 1);
      if (firstParagraph < 0 || !remainder.length || remainder.map(child => child.textContent).join('').length < 250) return;
      guide.dataset.guideReady = 'true';
      const details = document.createElement('div');
      details.className = 'rf-guide-details';
      details.id = `rf-guide-details-${index}-${Date.now()}`;
      remainder.forEach(child => details.append(child));
      content.append(details);
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'rf-guide-toggle';
      button.setAttribute('aria-controls', details.id);
      guide.append(button);
      let expanded = false;
      function update() {
        const collapsed = mobile.matches && !expanded;
        details.hidden = collapsed;
        guide.classList.toggle('rf-guide-collapsed', collapsed);
        button.textContent = expanded ? less : more;
        button.setAttribute('aria-expanded', String(!collapsed));
      }
      button.addEventListener('click', () => {
        expanded = !expanded;
        update();
        if (!expanded && button.getBoundingClientRect().top < 0) button.scrollIntoView({ block: 'center', behavior: 'instant' });
      });
      mobile.addEventListener('change', update);
      update();
    });
  }
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
